//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Filter from '../Filter/Filter';
import RangeDouble from '../Range/RangeDouble';
import {HotelSearchProxy} from "@/http/RequestProxy.class";
import utils from "../../utils/utils";

const hotelSearchProxy = new HotelSearchProxy();

export default {
  name: 'hotel-filter',
  components: {
    'i-filter': Filter,
    RangeDouble,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    currencyCode: {
      type: String,
      default: 'CNY',
    },
    isShowSort: {
      type: Boolean,
      default: true,
    }
  },
  data(){
    return {
      maxPrice: 0,
      conditions: {
        roomCategory: null,
        options: [],
      },
      // 酒店服务设施和餐饮等选项等内容
      options: [],
      // 筛选条件详细内容（返回给搜索列表）
      selectHash: [],
      // 筛选条件字段内容（返回给搜索列表）
      params: {
        price_from: '',
        price_to: '',
        room_category: '',
        options: '',
        filter_options: '',
      },
    };
  },
  methods: {
    /** 获取筛选条件数据 */
    getFilterConditions(){
      this.$vux.loading.show({text: this.$i18n.t('hotel.LOADING')});
      hotelSearchProxy.getHotelFilterConditions_V2()
        .then(resp => {
          if(resp){
            this.maxPrice = Number(resp.data.max_price);
            // this.params.price_to = Number(this.maxPrice);
            this.conditions.options = resp.data.options;
            this.conditions.roomCategory = resp.data.room_category;
            // this.options = new Array(resp.data.options.length);
          }
          this.$vux.loading.hide();
        });
    },

    /** 选择房型/设施服务条件 */
    onSelectFilter(ev, optIndex){
      const dataset = ev.target.dataset;
      const {code} = dataset;

      if(typeof optIndex != 'undefined'){
        const curIdx = this.options.indexOf(code);

        if(curIdx > -1){
          // this.$set(this.options, optIndex, code);
          this.options.splice(curIdx, 1);
          this.selectHash.forEach((ipts, idx) => {
            if(code === ipts.code){
              this.selectHash.splice(idx, 1);
            }
          });
        }else{
          const hash = {
            code: code,
            name: dataset.name
          };

          this.options.push(code);
          if(hash.name){
            this.selectHash.push(hash);
          }
        }

        this.params.filter_options = this.arrayJoinToString(this.options, ',');
      }else{
        // this.params.room_category = code;
        // this.selectHash.roomCategory = {code: code, name: dataset.name};
      }
    },

    /** 确定筛选条件 */
    onConfirmFilter(sortBy){
      let filterParams = Object.assign({}, this.params, sortBy);
      let priceHash;

      if(this.params.price_to && (this.params.price_from > 0 || this.params.price_to < this.maxPrice)){
        priceHash = {
          price_from: this.params.price_from,
          price_to: this.params.price_to,
        };
      }else{
        priceHash = {
          price_from: '',
          price_to: '',
        };
      }

      this.$emit('on-filter', {filterParams: filterParams, conditionsHash: this.selectHash, priceRange: priceHash});
    },

    /** 重置筛选条件 */
    onResetFilter(){
      // this.options.forEach((it, idx) => {
      //   this.$set(this.options, idx, '');
      // });
      this.options = [];
      this.selectHash = [];
      this.params.filter_options = '';
      this.params.room_category = '';
      this.params.price_from = '';
      this.params.price_to = '';
      this.$refs.rangeDouble.initProgress();
    },

    /** 条件删除: type = 1删除房型条件，type = 2删除其他条件 */
    delCondition(type = 1, idx){
      // console.log(this.selectHash.otherOptions);

      if(type == 1){
        // this.params.room_category = '';
        // this.selectHash.roomCategory = '';
      }else if(type == 2){
        this.options.splice(idx, 1);
        this.params.filter_options = this.arrayJoinToString(this.options, ',');
        this.selectHash.splice(idx, 1);
      }else{
        this.params.price_from = '';
        this.params.price_to = '';
      }

      // this.$emit('on-filter', {filterParams: this.params, conditionsHash: this.selectHash});
      this.$emit('on-filter', {filterParams: this.params, conditionsHash: this.selectHash});
    },

    /** 将字数组拼接为数组 */
    arrayJoinToString(source, format){
      return source.filter(it => it != '').join(format);
    },

    /** 显示筛选菜单 */
    onOpenFilter(){
      if(!this.conditions.roomCategory){
        setTimeout(() => {
          this.getFilterConditions();
        }, 200);
      }
    },

    /** 关闭筛选 */
    onCloseFilter(){
      this.$emit('on-close');
    },

    onGetMin(resp){
      this.params.price_from = resp;
    },

    onGetMax(resp){
      this.params.price_to = resp;
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/HotelFilter/HotelFilter.vue